import { useEffect } from "react";
import { useLocation, useParams } from "react-router";

import { TrackingLayout } from "./layout";
import TrackingScreen from "./tracking.screen";
import { tracklinkRedirectUrl } from "./tracking-destination";

export function TrackingRoute() {
  const { trackingNumber = "" } = useParams<{ trackingNumber: string }>();
  const { search } = useLocation();
  const redirectUrl = tracklinkRedirectUrl(trackingNumber, search);

  useEffect(() => {
    if (redirectUrl) window.location.replace(redirectUrl);
  }, [redirectUrl]);

  if (redirectUrl) return null;

  return (
    <TrackingLayout>
      <TrackingScreen />
    </TrackingLayout>
  );
}
